import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { isAdOptOut, savePrefs } from "../../utils/privacyConsent";

// "Do Not Sell or Share My Personal Information" — web app / qushi.io only.
// It is opened from the desktop-only "Privacy Choices" section of Settings and
// is never shown in the mobile app.
//
// The switch is an OPT-OUT for ad-measurement sharing: turning it ON stops
// sharing (status reads "off"); leaving it off keeps sharing on (the default).
//
// The choice is held in the shared privacy store, so it is the same preference
// the visitor set on qushi.io and it reaches every tag through Consent Mode. It
// moves the three advertising states only — opting out of targeted advertising
// must never switch off ordinary analytics. A Global Privacy Control signal
// shows up here as an opt-out already in place, without the visitor doing
// anything.
const DoNotSellModal = ({ isOpen, onClose }) => {
  const [optOut, setOptOut] = useState(() => isAdOptOut());

  if (!isOpen) return null;

  const toggle = () => {
    setOptOut((prev) => {
      const next = !prev;
      savePrefs({ doNotSellOrShare: next });
      return next;
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative z-10 w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
        >
          <MdClose size={22} />
        </button>

        <h2 className="pr-8 text-title-subpage font-bold text-[#004d4d]">
          Do Not Sell or Share My Personal Information
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-gray-600">
          Control whether QUSHi can share activity data with advertising
          platforms to measure which of our ads are working. This does not
          affect your account.
        </p>

        {/* Spacing, then the toggle row — text left, switch right. */}
        <div className="mt-8 flex items-start justify-between gap-4">
          <div>
            <p className="font-medium text-gray-800">Ad measurement sharing</p>
            <p className="mt-0.5 text-sm text-secondary">
              {optOut
                ? "Sharing for ad measurement is off"
                : "Sharing for ad measurement is on"}
            </p>
          </div>

          <div
            onClick={toggle}
            role="switch"
            aria-checked={optOut}
            className="flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full transition-all"
            style={{
              backgroundColor: optOut ? "#35b23c" : "#d3d3d3",
              justifyContent: optOut ? "flex-end" : "flex-start",
              padding: "3px",
            }}
          >
            <div className="h-6 w-6 rounded-full bg-white shadow" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoNotSellModal;
